package com.shadowings.gero.data.lessons.chapter10

import com.shadowings.gero.data.lessons.chapter8.getEndingVsoQuizContent
import com.shadowings.gero.data.repository.DatabaseRepositoryImpl
import com.shadowings.gero.data.repository.SentenceOptions
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_la_forma_vso_1
import gero.composeapp.generated.resources.exp_content_la_forma_vso_2
import gero.composeapp.generated.resources.exp_content_la_forma_vso_3
import gero.composeapp.generated.resources.exp_content_la_forma_vso_4
import gero.composeapp.generated.resources.exp_content_la_forma_vso_5
import gero.composeapp.generated.resources.exp_title_la_forma_vso

fun getLaFormaVsoContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_la_forma_vso,
            content = Res.string.exp_content_la_forma_vso_1,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_forma_vso,
            content = Res.string.exp_content_la_forma_vso_2,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_forma_vso,
            content = Res.string.exp_content_la_forma_vso_3,
            face = Faces.Serious,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_forma_vso,
            content = Res.string.exp_content_la_forma_vso_4,
            face = Faces.Surprised,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_forma_vso,
            content = Res.string.exp_content_la_forma_vso_5,
            face = Faces.Happy,
            character = Characters.Masko,
        )
    )
}

fun getLaFormaVsoQuizContent(
    languageCode: String,
    verbSentences: List<SentenceOptions> = DatabaseRepositoryImpl.verbSentences
): List<IQuizContent> {
    return getEndingVsoQuizContent(languageCode, verbSentences)
}
